import { Box, Typography, List, ListItem, Link } from "@mui/material";

export default function ResourcesTab({data}) {
  console.log("ResourcesTab data:", data);
  const resources = [
    { title: "Course PDF Notes", url: data.resources },
    // { title: "Sample Code Files", url: "#" },
    // { title: "Assignment Sheets", url: "#" },
  ];
  console.log(data.course)

  return (
    <Box>
      <Typography variant="h6" mb={1}>Course Resources</Typography>

      <List>
        {resources.map((res, idx) => (
          <ListItem key={idx} sx={{ paddingLeft: 0 }}>
            <Link href={res.url} target="_blank" underline="hover">
              {res.title}
            </Link>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
